export class Form {
    constructor(formTemplate) {
        this.formElement = formTemplate.content
            .querySelector(".todos__form")
            .cloneNode(true);
        this.inputField = this.formElement.querySelector(".todo-form__input");
        this.formElement.addEventListener("submit", (evt) => {
            evt.preventDefault();
            this.handleFormSubmit(this.inputField.value);
        });
    }
    setHandler(handleFormSubmit) {
        this.handleFormSubmit = handleFormSubmit;
    }
    render() {
        return this.formElement;
    }
    setValue(data) {
        this.inputField.value = data;
    }
    getValue() {
        return this.inputField.value;
    }
    clearValue() {
        this.formElement.reset();
    }
    set buttonText(data) {
        this.submitButton.textContent = data;
    }
    set placeholder(data) {
        this.inputField.placeholder = data;
    }
}
